import { useEffect, useState } from 'react'

import { useFetchStorageMutation } from '@redux/api'

import { AutocompleteOption } from '@types'

export const useDepartmentOptions = ({ hideHardCodeFilters }: { hideHardCodeFilters: boolean }) => {
  const [fetchStorage] = useFetchStorageMutation()
  const [options, setOptions] = useState<AutocompleteOption[]>([])
  useEffect(() => {
    if (hideHardCodeFilters) {
      return
    }

    fetchStorage({ objectCode: 'roster-department' })
      .unwrap()
      .then(res => {
        if (Array.isArray(res)) {
          setOptions(res.map(dep => ({ id: dep['dep_id'], label: dep['dep_name'] })))
        }
      })
  }, [hideHardCodeFilters])

  return options
}
